/**
 * Controller: TemplatesShowAccountsModal
 */
angular.module('acme.view.application.templates.showAccountsModal.controllers', [])
.controller('TemplatesShowAccountsModalController', [ '$scope', '$uibModalInstance', 'AccountsListData', function ($scope, $uibModalInstance, AccountsListData) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {
      if (AccountsListData.data && AccountsListData.data.success) {
        $scope.handlers.success.init(AccountsListData);
      }else{
        $scope.handlers.error.init(AccountsListData);
      }
    };

    $scope.hasData = function() {
      return ($scope.model instanceof Array && $scope.model.length > 0);
    };

    $scope.handlers = {
      success: {
        init: function(response) {
          $scope.model = response.data.payload;
        }
      },
      error: {
        init: function (response) {
          $scope.errors = [
            {
              message: response.data.error
            }
          ];
        }
      }
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);